import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, get, } from "firebase/database";
let db;
export function configureDatabase() {
    const firebaseConfig = {
        databaseURL: "https://cedar-park-church-slides-default-rtdb.firebaseio.com",
    };
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    db = getDatabase(app);
}
export function database() {
    return db;
}
export function dataRef(dbRef) {
    if (typeof dbRef === "string") {
        dbRef = ref(db, dbRef);
    }
    return dbRef;
}
export function dataOnce(dbRef) {
    return get(dataRef(dbRef)).then((snapshot) => {
        return snapshot.val();
    });
}
export function dataOn(dbRef, callback) {
    onValue(dataRef(dbRef), (snapshot) => {
        callback(snapshot.val());
    });
}
